









































































import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { ReferralInfo } from "@foxone/api/src/models/foxone";
import utils from "basis/utils";

@Component
class ReferralCode extends Vue {
  @State(state => state.basis.account.referral) referral!: ReferralInfo;

  downloading = false;

  referralURL = "";

  showReferralImage = false;

  get code() {
    return this.referral.referral_code;
  }

  get link() {
    return `${this.$common.configs.WEB_HOST}/basis/invite?code=${this.code}`;
  }

  handleToShare() {
    this.$helper.toFusionPath(this, "basis", {
      name: "invite",
      query: { code: this.code }
    });
  }

  handleDownload() {
    this.downloading = true;
    utils.invite.genInviteImage(this, this.code, this.link, url => {
      this.downloading = false;
      this.showReferralImage = true;
      this.referralURL = url;
    });
  }
}
export default ReferralCode;
